import { Injectable } from "@angular/core";
import { IID_OL_SOSPENSIONE } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolSospensioneStore } from "./iidOlSospensione.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_SOSPENSIONE)
export class IIDolSospensioneQuery extends AbstractInterfaceDataQuery<IID_OL_SOSPENSIONE> {
  constructor(protected store: IIDolSospensioneStore) {
    super(store);
  }
}
